<template>
  <b-card>
    <h1>Total patients</h1>
    <vue-apex-charts :options="chartOptions" :series="series" type="bar" />
    <mixn ref="mixin" />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import mixn from '@/components/mixn.vue'

export default {
  components: {
    BCard,
    VueApexCharts,
    mixn,
  },
  props: {
    userData: { type: Object, default: () => ({}) },
    dataDashboard: { type: Object, required: true, default: () => ({}) },
    fechas: { type: Object, required: true, default: () => ({}) },
    dateMembership: { type: Object, required: true, default: () => ({}) },
  },
  data() {
    return {
      chartOptions: {
        tooltip: {
          x: { show: false },
          y: {
            title: {
              formatter: () => '',
            },
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: { position: 'top' },
            columnWidth: '50%',
          },
        },
        dataLabels: {
          offsetY: -25,
          style: {
            colors: ['#333'],
            fontSize: '11px',
          },
        },
      },
      series: [],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    }
  },
  watch: {
    dataDashboard: {
      handler() {
        const { start, end } = this.fechas

        const oneDayMilliseconds = 24 * 60 * 60 * 1000
        const startDate = start ? new Date(start) : null
        const endDate = end ? new Date(end) : null
        const daysDifference =
          startDate && endDate
            ? Math.round((endDate - startDate) / oneDayMilliseconds)
            : null

        if (!start || !end || daysDifference > 31) {
          this.series = this.getMergedMonthlyData()
        } else {
          this.series = [{ data: this.getMergedDailyData() }]
        }
      },
      immediate: true,
    },
  },
  methods: {
    getMergedDailyData() {
      const colores = this.$refs.mixin.listaColores()
      const membershipByDate = this.getSumByDay(this.dateMembership)

      const membershipMap = {}
      membershipByDate.forEach(item => {
        membershipMap[item.fecha] = item.suma
      })

      return this.dataDashboard.patients_per_day
        .map((entry, index) => {
          const fecha = `${entry.year}-${entry.month.padStart(2, '0')}-${entry.day.padStart(2, '0')}`
          const count = entry.count || 0
          const extra = membershipMap[fecha] || 0
          const color = colores[index] || this.$refs.mixin.colorGenerator()
          return {
            x: entry.day.padStart(2, '0'),
            y: count + extra,
            fillColor: color,
            day: parseInt(entry.day, 10),
          }
        })
        .sort((a, b) => a.day - b.day)
    },

    getMergedMonthlyData() {
      const colores = this.$refs.mixin.listaColores()
      const membershipByDate = this.getSumByDay(this.dateMembership)

      // Agrupa sumas por mes y año
      const membershipByMonthYear = {}
      membershipByDate.forEach(({ fecha, suma }) => {
        const [year, month] = fecha.split('-')
        const key = `${year}-${month}`
        membershipByMonthYear[key] = (membershipByMonthYear[key] || 0) + suma
      })

      const data = this.dataDashboard.patients_per_month.map((entry, index) => {
        const key = `${entry.year}-${entry.month.padStart(2, '0')}`
        const extra = membershipByMonthYear[key] || 0
        const color = colores[index] || this.$refs.mixin.colorGenerator()
        return {
          x: `${this.months[parseInt(entry.month) - 1]} - ${entry.year}`,
          y: (entry.count || 0) + extra,
          fillColor: color,
        }
      })

      data.sort((a, b) => new Date(a.x) - new Date(b.x))
      return [{ data }]
    },

    getSumByDay(dateMembership) {
      return Object.entries(dateMembership)
        .filter(([key]) => key !== '__ob__')
        .map(([fecha, valores]) => {
          const suma = (valores.NC || 0) + (valores.NP || 0)
          return { fecha, suma }
        })
    },
  },
}
</script>
